import React from "react";
import { ShieldCheck, Award, Users, Check, Phone, Mail } from "lucide-react";
import ContactForm from "../components/ContactForm";

export default function Firmaordning() {
  return (
    <div className="bg-white text-neutral-900 min-h-screen">
      {/* Page Header */}
      <section className="bg-black text-white py-16 border-b border-neutral-900 text-center relative overflow-hidden">
        <div className="absolute inset-0 z-0 opacity-25">
          <img
            src="https://assets.auxodev.dk/assets/0fa1183b-3f51-46de-aff6-df593e862933/898aa03e-7ed9-493b-80a1-3c235fae6c88.jpg"
            alt="Firmaordning baggrund"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="relative z-10 max-w-4xl mx-auto px-6">
          <span className="text-xs font-bold uppercase tracking-[0.3em] text-neutral-400 block mb-2">
            Frokost til virksomheder
          </span>
          <h1 className="text-4xl md:text-5xl font-serif font-bold tracking-tight">
            Firmaordning
          </h1>
          <p className="text-sm text-neutral-400 max-w-lg mx-auto leading-relaxed">
            Ønsker I lidt ekstra af det sunde i det daglige – så er en frokostordning fra Hillerød Smørrebrød det helt rigtige valg.
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20 max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 items-start">
          {/* Left Column: Info */}
          <div className="lg:col-span-7 space-y-8">
            <div>
              <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#2d5a27] block mb-2">
                Kvalitet & Service i top
              </span>
              <h2 className="text-3xl font-serif font-bold text-neutral-900 tracking-tight">
                Frisk og lækker madpakkeordning lige til arbejdspladsen
              </h2>
              <p className="text-neutral-600 leading-relaxed">
                Hos os er kvalitet og service i top og vores frokostkoncepter er præget af personlighed krydret med passion for det, vi laver.
              </p>
            </div>

            <div className="bg-neutral-50 p-8 border border-neutral-200">
              <h3 className="font-serif font-bold text-lg text-neutral-900 mb-4">
                Du kan vælge mellem:
              </h3>
              <ul className="space-y-3">
                <li className="flex items-start gap-3 text-neutral-700 text-sm">
                  <Check className="text-[#2d5a27] shrink-0 mt-0.5" size={18} />
                  <span><strong>4 styk smørrebrød</strong> – Klassisk, højtbelagt og frisksmurt.</span>
                </li>
                <li className="flex items-start gap-3 text-neutral-700 text-sm">
                  <Check className="text-[#2d5a27] shrink-0 mt-0.5" size={18} />
                  <span><strong>Sandwich</strong> – Lavet i vores lækre, hjemmelavede boller.</span>
                </li>
                <li className="flex items-start gap-3 text-neutral-700 text-sm">
                  <Check className="text-[#2d5a27] shrink-0 mt-0.5" size={18} />
                  <span><strong>Stor bakke salat</strong> – Frisk, sund og mættende.</span>
                </li>
              </ul>
            </div>

            <p className="text-neutral-600 leading-relaxed">
              De er altid velkommen til at kontakte os for yderligere information eller ved spørgsmål. Vi skræddersyr gerne en frokostaftale, der passer præcis til jeres virksomheds ønsker og behov.
            </p>

            {/* Corporate Features */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 pt-6 border-t border-neutral-200">
              <div className="flex flex-col items-center sm:items-start text-center sm:text-left">
                <Users className="text-[#2d5a27] mb-2" size={24} />
                <h4 className="font-serif font-bold text-sm text-neutral-900">Tilpasset jer</h4>
                <p className="text-xs text-neutral-500 mt-1">Fleksible løsninger til både små og store kontorer.</p>
              </div>
              <div className="flex flex-col items-center sm:items-start text-center sm:text-left">
                <ShieldCheck className="text-[#2d5a27] mb-2" size={24} />
                <h4 className="font-serif font-bold text-sm text-neutral-900">Pålidelig levering</h4>
                <p className="text-xs text-neutral-500 mt-1">Vi leverer altid friskt og præcist til aftalt tid.</p>
              </div>
              <div className="flex flex-col items-center sm:items-start text-center sm:text-left">
                <Award className="text-[#2d5a27] mb-2" size={24} />
                <h4 className="font-serif font-bold text-sm text-neutral-900">Højeste kvalitet</h4>
                <p className="text-xs text-neutral-500 mt-1">Kun de bedste og mest friske råvarer bruges.</p>
              </div>
            </div>
          </div>

          {/* Right Column: Inquiry Form */}
          <div className="lg:col-span-5">
            <div className="sticky top-32">
              <ContactForm subject="Firmaordning forespørgsel" />
              <div className="mt-6 bg-neutral-50 p-6 border border-neutral-200 text-center">
                <p className="text-xs text-neutral-500">
                  Du kan også ringe direkte til os for en uforpligtende snak:
                </p>
                <a
                  href="tel:48266613"
                  className="inline-block mt-2 font-serif font-bold text-lg text-neutral-900 hover:text-[#2d5a27] transition-colors"
                >
                  48 26 66 13
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
